import { Client } from "./_clientService";

export async function getVaultRewardConfigs(payload: any) {
  const resp = await new Client({
    path: `/vault-reward-config/list`,
    payload,
  }).post();

  return resp;
}

export async function createVaultRewardConfig(payload: any) {
  const resp = await new Client({
    path: `/vault-reward-config/create`,
    payload,
  }).post();

  return resp;
}

export async function updateVaultRewardConfig(payload: any) {
  const resp = await new Client({
    path: `/vault-reward-config/update`,
    payload,
  }).post();

  return resp;
}

export async function deleteVaultRewardConfig(vaultRewardConfigId: any) {
  const client = new Client({
    path: `/vault-reward-config/delete`,
    payload: { vaultRewardConfigId },
  });

  const resp = await client.post();

  return resp;
}

export async function getVaultRewardConfigInfo(vaultRewardConfigId: any) {
  const resp = await new Client({
    path: `/vault-reward-config/info`,
    payload: { vaultRewardConfigId },
  }).post();

  return resp;
}
